export const Process = {
    env:{
        'VUE_APP_CYCORE':process.env.VUE_APP_CYCORE,
        'VUE_APP_ENV':process.env.VUE_APP_ENV,
        'VUE_APP_PASS':process.env.VUE_APP_PASS,
        'VUE_APP_CYCORE_HOST':process.env.VUE_APP_CYCORE_HOST,
    }
}


// WEBPACK FOOTER //
// ./src/request/host.js